export const DEFAULT_FORMFIELD_AXENA = {
  otherICD10Code: '',
  prnReplacementQuantity: '',
  directionsForUseApply: '',

  storeFax: '877-800-4371',
  storeEmail: 'fax@levacares.com',

  'checkbox-N393': false,
  'checkbox-N3941': false,
  'checkbox-N3946': false,
  'checkbox-N3281': false,
  'checkbox-R159': false,
  'checkbox-OTHER': false,

  'checkbox-related-clinical-notes': true,
};

export const ICD10CODES = [
  {
    questionId: 'N393',
    label: 'N39.3 Stress Incontinence',
    isModificationAllowed: true,
  },
  {
    questionId: 'N3941',
    label: 'N39.41 Urgency Incontinence',
    isModificationAllowed: true,
  },
  {
    questionId: 'N3946',
    label: 'N39.46 Mixed Incontinence',
    isModificationAllowed: true,
  },
  {
    questionId: 'N3281',
    label: 'N32.81 Overactive Bladder',
    isModificationAllowed: true,
  },
  {
    questionId: 'R159',
    label: 'R15.9 Fecal Incontinence',
    isModificationAllowed: true,
  }
];

export const OFFICE_INSTRUCTIONS = [
  {
    questionId: 'related-clinical-notes',
    label: 'Related Clinical Notes',
    isModificationAllowed: true,
  }
];
